import React, { useMemo, useState, useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Button57 from '../components/Button57';
import { storage } from "../common/storage";

const { FiSearch, FiPhone, FiMapPin, FiClock, FiHeart } = FiIcons;

const MENU_DATA = {
  categories: [
    {
      id: "lunch",
      name: "Lunch Special",
      note: "11:00 AM – 3:00 PM (NOTE: Only items #1-#6 are served with rice, miso soup, salad, 4pcs. California roll, Shrimp & Vegetable Tempura)",
      items: [
        { name: "#1 Beef Bulgogi Bento Box", price: 12.95 },
        { name: "#2 Chicken Teriyaki Bento Box", price: 11.95 },
        { name: "#3 Salmon Teriyaki Bento Box", price: 12.95 },
        { name: "#4 Mixed Tempura Bento Box", price: 11.95 },
        { name: "#5 Pork Katsu Bento Box", price: 10.95 },
        { name: "#6 Chicken Katsu Bento Box", price: 10.95 },
        { name: "#7 California Roll (2 Rolls)", price: 10.95 },
        { name: "#8 Spicy Tuna Roll (2 Rolls)", price: 10.95 },
        { name: "#9 California Roll & Sushi Combo", price: 13.95, desc: "1 roll & 4 pcs sushi" },
        { name: "#10 Spicy Tuna Roll & Sushi Combo", price: 13.95, desc: "1 roll & 4 pcs sushi" },
        { name: "#11 Sushi, Sashimi & Spicy Tuna Combo", price: 16.95, desc: "4 pcs sushi, 4 pcs sashimi & 1 roll" }
      ],
    },
    {
      id: "rolls",
      name: "Classic Rolls",
      items: [
        { name: "#1 Tuna Maki Roll", price: 6.25 },
        { name: "#2 Tuna Avocado Roll", price: 6.95 },
        { name: "#3 Salmon Maki Roll", price: 6.25 },
        { name: "#4 Salmon Avocado Roll", price: 6.95 },
        { name: "#5 YellowTail Maki Roll", price: 6.50 },
        { name: "#6 YellowTail Scallion Roll", price: 7.95 },
        { name: "#7 White Tuna Avocado Roll", price: 6.95 },
        { name: "#8 Eel Avocado Roll", price: 6.95 },
        { name: "#9 California Roll", price: 6.00 },
        { name: "#10 California Masago Roll", price: 6.50 },
        { name: "#11 Alaska Roll", price: 6.95, desc: "Salmon, Avocado, Cucumber" },
        { name: "#12 Boston Roll", price: 6.95, desc: "Shrimp, Crab, Cucumber, topped with Spicy Mayo" },
        { name: "#13 Salmon Teriyaki Roll", price: 6.95 },
        { name: "#14 Chicken Teriyaki Roll", price: 6.95 },
        { name: "#15 Crab Stick Tempura Roll", price: 6.00 },
        { name: "#16 Sweet Potato Tempura Roll", price: 6.00 },
        { name: "#17 Philedelphia Roll", price: 7.50, desc: "Salmon, Avocado, Cream Cheese"},
        { name: "#18 Spicy Tuna Roll", price: 6.95 },
        { name: "#19 Spicy Salmon Roll", price: 6.95 },
        { name: "#20 Spicy YellowTail Roll", price: 6.95 },
        { name: "#21 Spicy Shrimp Roll", price: 6.95 },
        { name: "#22 Spicy Crab Roll", price: 6.95 },
        { name: "#23 Spicy California Roll", price: 6.50 },
        { name: "#24 Avocado Roll", price: 5.50 },
        { name: "#25 Avacado Cucumber Roll", price: 5.50 },
        { name: "#26 Avocado Seaweed Salad Roll", price: 5.95 },
        { name: "#27 Cucumber Roll", price: 5.00 },
        { name: "#28 Mango Roll", price: 5.25 }
      ],
    },
    {
      id: "special-rolls",
      name: "Special Rolls",
      items: [
        { name: "A1. A to Z Roll", price: 8.95, desc: "Shrimp, Crab, Avocado, Top Spicy Mayo, Masago" },
        { name: "A2. Big Bang Roll 1", price: 9.95, desc: "Shrimp, Crab, Avocado, Cream Cheese, Top Spicy Mayo,Masago" },
        { name: "A3. Big Bang Roll 2", price: 9.95, desc: "Shrimp, Crab, Avocado, Cream Cheese, Top Spicy Mayo,Crunch" },
        { name: "A4. Crunch Tuna Roll", price: 8.95, desc: "Tuna, Avocado, Cream Cheese, Top Crunch, Spicy Mayo" },
        { name: "A5. Crunch Salmon Roll", price: 8.95, desc: "Salmon, Avocado, Cream Cheese, Top Crunch, Spicy Mayo" },
        { name: "A6. Dragon Roll 1", price: 10.95, desc: "Eel, Avacado, Tuna, Top Avocado, Japanese Mayo" },
        { name: "A7. Dragon Roll 2", price: 12.95, desc: "Eel, Avacado, Cucumber, Top Eel, Eel Sauce" },
        { name: "A8. Golden Roll", price: 12.95, desc: "Salmon, Avocado, Top Salmon, Spicy Mayo, Masago" },
        { name: "A9. Green Roll", price: 10.95, desc: "Salmon, Mango, Top Avocado, Spicy Mayo, Crunch" },
        { name: "A10. House Special Roll", price: 18.95, desc: "Tuna, Salmon, YellowTail, Crab, Cream Cheese, Top Spicy Tuna, Avocado, Spicy Mayo, Masago" },
        { name: "A11. Love Love Roll", price: 9.95, desc: "Soybean Paper, Salmon, Tuna, Avocado, Top Spicy Mayo" },
        { name: "A12. Manhattan Roll", price: 13.95, desc: "Tuna, Salmon, Crab, Avocado, Tamago, Masago, Top Spicy Mayo" },
        { name: "A13. Monster Mountain Roll", price: 20.95, desc: "Tuna, Salmon, White Tuna, YellowTail, Avocado, Cream Cheese, Top Spicy Tuna, Spicy Salmon, Spicy YellowTail, Spicy Mayo, Eel Sauce, Crunch" },
        { name: "A14. New York Roll", price: 13.95, desc: "Tuna, Salmon, Crab, Avocado, Top Spicy Mayo, Masago" },
        { name: "A15. NY Giants Roll", price: 15.95, desc: "Tuna, Salmon, YellowTail, Crab, Tamago, Top Avocado, Spicy Mayo, Eel Sauce, Crunch" },
        { name: "A16. Pink Lady Roll 1", price: 11.95, desc: "Soybean Paper, Tuna, Salmon, Crab, Avocado, Cucumber, Top Spicy Mayo" },
        { name: "A17. Pink Lady Roll 2", price: 11.95, desc: "Soybean Paper, Salmon, Crab, Avocado, Top Mango, Spicy Mayo, Masago" },
        { name: "A18. Rainbow Roll 1", price: 12.95, desc: "Tuna, Salmon, Crab, Cucumber, Top Tuna, Salmon, Avocado" },
        { name: "A19. Rainbow Roll 2", price: 12.95, desc: "Crab, Tempura, Avacado, Cucumber, Top Tuna, Salmon, Spicy Mayo, Crunch" },
        { name: "A20. Red Roll", price: 11.95, desc: "Tuna, Avocado, Masago, Top Tuna, Spicy Mayo, Tobiko" },
        { name: "A21. Star Roll", price: 14.95, desc: "YellowTail, Avocado, Top YellowTail, Spicy Mayo, Eel Sauce, Scallion, Masago" },
        { name: "A22. St. John's Roll", price: 9.95, desc: "Shrimp, Crab, Avacado, Crunch, Top Masago, Spicy Mayo" },
        { name: "A23. Tropical Roll", price: 14.95, desc: "Tuna, Salmon, YellowTail, Avocado, Cucumber, Spicy Mayo, Masago" },
        { name: "A24. Volcano Roll 1", price: 10.95, desc: "Shrimp, Avacado, Cucumber, Top Spicy Tuna, Spicy Mayo, Eel Sauce, Crunch" },
        { name: "A25. White House Roll", price: 12.95, desc: "White Tuna, Avocado, Top White Tuna, Spicy Mayo, Eel Sauce, Masago" },
        { name: "A26. White Mountain Roll", price: 12.95, desc: "Shrimp Tempura, Cucumber, Top Crab, Spicy Mayo, Masago" }
      ],
    },
    {
      id: "spicy-special-rolls",
      name: "Spicy Special Rolls",
      items: [
        { name: "B1. Beyonce Roll 1", price: 10.95, desc: "Spicy Tuna, Salmon, crab, crunch, topped with Spicy Mayo" },
        { name: "B2. Beyonce Roll 2", price: 11.95, desc: "Spicy Salmon, Crunch, Top Salmon, Avacado, topped with Spicy Mayo" },
        { name: "B3. Dynamic Roll", price: 11.95, desc: "Spicy tuna, Crunch, Top Tuna, Avocado, Spicy Mayo, Eel Sauce, Masago" },
        { name: "B4. Fire Cracker Roll", price: 10.95, desc: "Crab, Avocado, Cucumber, Top Spicy Tuna, Spicy Mayo, Eel Sauce, Masago" },
        { name: "B5. Hurricane Roll", price: 10.95, desc: "Spicy Kani, Spicy Tuna, Top Mango, Avocado, Sweet Sauce" },
        { name: "B6. Paradise Roll", price: 11.95, desc: "Spicy Tuna, Crunch, Top Tuna, White Tuna, Avocado, Spicy Mayo, Eel Sauce, Masago" },
        { name: "B7. Transformer Roll", price: 10.95, desc: "Spicy Tuna, Crab Top, Avocado, Spicy Mayo, Eel Sauce, Crunch" }
      ],
    },
    {
      id: "tempura-special-rolls",
      name: "Tempura Special Rolls",
      items: [
        { name: "C1. A.C. Roll", price: 12.95, desc: "Shrimp Tempura, Crab, Avocado, Top Salmon, Masago, Spicy Mayo" },
        { name: "C2. Angel Roll", price: 13.95, desc: "Shrimp Tempura, Crab, Cucumber, Top Eel, Avocado, Masago, Eel Sauce" },
        { name: "C3. Blue Mountain Roll", price: 12.95, desc: "Salmon Tempura, Cucumber, Avocado, Spicy Mayo, Crunch" },
        { name: "C4. Butterfly Roll", price: 11.95, desc: "Shrimp Tempura, Cream Cheese, Avocado, Spicy Mayo, Masago" },
        { name: "C5. Godzilla Roll 1", price: 9.95, desc: "Deep Fried Spicy Tuna, Avocado, Top Scallion, Masago, Teriyaki Sauce" },
        { name: "C6. K.F.C Roll", price: 8.95, desc: "Chicken Tempura, Top Spicy Mayo, Teriyaki Sauce, Crunch" },
        { name: "C7. Kim & Kim Roll", price: 12.95, desc: "Shrimp Tempura, Crab, Avocado, Salmon, Spicy Mayo, Crunch" },
        { name: "C8. King Roll", price: 14.95, desc: "Shrimp Tempura, Kani Salad, Avocado, Cucumber, Top Spicy Tuna, Spicy Mayo, Eel Sauce, Crunch" },
        { name: "C9. Mango Crunch Roll (Soybean Paper)", price: 11.95, desc: "Shrimp Tempura, Crab, Avocado, Mango, Crunch" },
        { name: "C10. Monster Roll", price: 20.95, desc: "Soft Shell Crab, Shrimp Tempura, Crab Tempura, Avocado, Cucumber, Cream Cheese, Top Spicy Tuna, Spicy Mayo, Eel Sauce, Crunch" },
        { name: "C11. Pom Pom Roll", price: 12.95, desc: "Shrimp Tempura, Spicy Kani, Avocado, Cucumber, Top Spicy Mayo, Eel Sauce, Crunch" },
        { name: "C12. Shrimp Tempura Roll", price: 8.95, desc: "Fried Shrimp Tempura, Crab, Avocado, Cucumber, Top Spicy Mayo & Crunch, Eel Sauce" },
        { name: "C13. Spider Roll", price: 11.95, desc: "Fried Soft Shell Crab, Avocado, Cucumber, Top Spicy Mayo, Eel Sauce, Crunch" },
        { name: "C14. Spicy Spider Roll", price: 16.95, desc: "Fried Soft Shell Crab, Avocado, Cucumber, Crab, Top Spicy Tuna, Spicy Mayo, Eel Sauce, Crunch" },
        { name: "C15. Volcano Roll 2", price: 12.95, desc: "Shrimp Tempura, Avocado, Cucumber, Top Spicy Tuna, Spicy Mayo, Eel Sauce, Masago" },
        { name: "C16. Panda Roll", price: 17.95, desc: "Soft Shell Crab, Avocado, Spicy Kani, Top Eel, Avocado, Eel Sauce, Spicy Mayo, Crunch" }
      ],
    },
    {
      id: "ganda-combo",
      name: "Ganda Combo",
      note: "Served with Miso Soup & Salad",
      items: [
        { name: "1. Salmon Combo", price: 16.95, desc: "Salmon Sushi (4 pcs) and Salmon Avocado Roll" },
        { name: "2. Tuna Combo", price: 16.95, desc: "Tuna Sushi (4 pcs) and Tuna Avocado Roll" },
        { name: "3. Yellowtail Combo", price: 17.95, desc: "Yellowtail Sushi (4 pcs) and Yellowtail Scallion Roll" },
        { name: "4. Salmon Deluxe", price: 24.95, desc: "Salmon Sushi (4 pcs), Salmon Sashimi (4 pcs), and Salmon Avocado Roll" },
        { name: "5. Tuna Deluxe", price: 24.95, desc: "Tuna Sushi (4 pcs), Tuna Sashimi (4 pcs), and Tuna Avocado Roll" },
        { name: "6. Yellowtail Deluxe", price: 26.95, desc: "Yellowtail Sushi (4 pcs), Yellowtail Sashimi (4 pcs), and Yellowtail Scallion Roll" },
        { name: "7. Fresh Roll Combo", price: 18.95, desc: "Tuna Avocado Roll, Salmon Avocado Roll, Yellowtail Scallion Roll" },
        { name: "8. Vegetable Roll Combo", price: 12.95, desc: "Avocado Roll, Cucumber Roll, and Sweet Potato Tempura Roll" },
        { name: "9. Spicy Roll Combo", price: 17.95, desc: "Spicy Tuna Roll, Spicy Salmon Roll, Spicy Crab Roll" },
        { name: "10. California Roll Combo", price: 15.95, desc: "California Rolls" },
        { name: "11. 3 Roll Combo", price: 18.95, desc: "California Roll, Spicy Tuna Roll, Shrimp Tempura Roll" }
      ],
    },
    {
      id: "poke",
      name: "Poke Bowls",
      note: "$14.95 (Served with miso soup)",
      items: [
        { name: "Tuna Poke Bowl", price: 14.95, desc: "Mixed vegetables, avocado, white rice, sauce" },
        { name: "Salmon Poke Bowl", price: 14.95, desc: "Mixed vegetables, avocado, white rice, sauce" },
        { name: "Tuna / Salmon Poke Bowl", price: 14.95, desc: "Mixed vegetables, avocado, white rice, sauce" }
      ],
    },
    {
      id: "teriyaki",
      name: "Teriyaki Meals",
      note: "Pan Fried with Teriyaki Sauce and Served with Rice, Miso soup, and our House salad",
      items: [
        { name: "Chicken Teriyaki", price: 15.95 },
        { name: "Beef Bulgogi", price: 18.95 },
        { name: "Shrimp Teriyaki", price: 18.95 },
        { name: "Salmon Teriyaki", price: 18.95 }
      ],
    },
    {
      id: "tempura-katsu",
      name: "Tempura / Katsu Meals",
      note: "Your Selection Below, Breaded with Deep Fried, Served with rice, miso soup, and house salad",
      items: [
        { name: "Vegetable Tempura", price: 13.95 },
        { name: "Mixed Tempura", price: 15.95 },
        { name: "Shrimp Tempura", price: 17.95 },
        { name: "Pork Katsu", price: 15.95 },
        { name: "Chicken Katsu", price: 15.95 }
      ],
    },
    {
      id: "korean",
      name: "Korean Food",
      items: [
        { name: "Beef Rice Bowl", price: 15.95 },
        { name: "# Chicken Rice Bowl", price: 12.95 },
        { name: "Shrimp Rice Bowl", price: 15.95 },
        { name: "Salmon Rice Bowl", price: 15.95 },
        { name: "Beef Bibim Bap", price: 15.95, desc: "with egg, white rice"},
        { name: "Chicken Bibim Bap", price: 13.95, desc: "with egg, white rice" },
        { name: "Shrimp Bibim Bap", price: 15.95, desc: "with egg, white rice" },
        { name: "Vegetable Bibim Bap", price: 11.95, desc: "with egg, white rice" }
      ],
    },
    {
      id: "noodles",
      name: "Udon & Ramen",
      items: [
        { name: "Vegetable Udon", price: 11.95 },
        { name: "Tempura Udon", price: 15.95 },
        { name: "Vegetable Ramen", price: 10.95 },
        { name: "Beef Ramen", price: 13.95 },
        { name: "Chicken Ramen", price: 12.95 }
      ],
    },
    {
      id: "apps",
      name: "Appetizers & Starters",
      items: [
        { name: "#1 French Fries", price: 4.50 },
        { name: "#2 Edamame", price: 5.50, desc: "Steamed soybeans, lightly salted" },
        { name: "#3 Shumai", price: 6.00, desc: "Steamed Shrimp Dumplings (6 pcs)" },
        { name: "#4 Gyoza", price: 6.50, desc: "Fried Pork or Vegetable or Chicken Dumplings (6 pcs)" },
        { name: "#5 Vegetable Tempura", price: 6.95, desc: "Assorted Vegetable Tempura (5pcs)" },
        { name: "#6 Chicken Wing", price: 8.99, desc: "Fried Chicken Wings (5pcs) with Sauce" },
        { name: "#7 Shrimp & Vegetable Tempura", price: 10.00, desc: "Vegetable Tempura (2pcs) and Shrimp Tempura (3pcs)" },
        { name: "#8 Shrimp Tempura", price: 11.00, desc: "Crispy Shrimp Tempura (5 pcs)" },
        { name: "#9 Vegetable Spring Roll", price: 6.50, desc: "Meatless Spring Roll (4 pcs)" }
      ],
    },
    {
      id: "salads",
      name: "Salad",
      items: [
       { name: "#1 House Salad", price: 4.00, desc: "Green Salad topped with our Homemade Dressing" },
       { name: "#2 Seaweed Salad", price: 5.50, desc: "Thinly Shredded Seaweed" },
       { name: "#3 Avocado Salad", price: 5.50, desc: "House Salad topped with Avocado" },
       { name: "#4 Kani Salad", price: 6.00, desc: "House Salad with Japanese Mayo or Spicy Mayo" },
       { name: "#5 Tuna Salad", price: 8.95, desc: "House Salad topped Tuna" },
       { name: "#6 Salmon Salad", price: 8.95, desc: "House Salad topped Salmon" },
       { name: "#7 Mixed Salad", price: 8.95, desc: "House Salad topped Tuna and Salmon" }
      ],
    },
    {
      id: "soups",
      name: "Soups",
      items: [
       { name: "Miso Soup", price: 3.00 },
       { name: "Dumpling Soup", price: 6.00, desc: "Pork or Vegetable or Chicken Dumpling"}
      ],
    },
    {
      id: "sushi-alacarte",
      name: "Sushi A La Carte",
      items: [
        { name: "Tuna", price: 3.25 },
        { name: "Eel", price: 4.00 },
        { name: "Tobiko", price: 4.00 },
        { name: "Ikura", price: 5.00 },
        { name: "White Tuna", price: 3.25 },
        { name: "YellowTail", price: 4.00 },
        { name: "Masago", price: 4.00 },
        { name: "Ika", price: 3.25 },
        { name: "Salmon", price: 3.25 },
        { name: "Crab Meat", price: 3.00 },
        { name: "Shrimp", price: 3.00 },
        { name: "Tamago", price: 3.00 }
      ],
    },
    {
      id: "sashimi",
      name: "Sashimi",
      items: [
        { name: "Sashimi Regular", price: 25.95, desc: "18 pcs (served with miso soup & salad)" },
        { name: "Sashimi Deluxe", price: 32.95, desc: "24 pcs (served with miso soup & salad)" },
        { name: "Sashimi Special", price: 42.95, desc: "32 pcs (served with miso soup & salad)" }
      ],
    },
    {
      id: "sushibarentrees",
      name: "Sushi Bar Entrees",
      items: [
        { name: "#1 Sushi", price: 22.95, desc: "Tuna (3), Salmon (3), YellowTail (2) and Spicy Tuna Roll" },
        { name: "#2 Sushi & Sashimi", price: 22.95, desc: "Sushi (4pcs.), Sashimi (4pcs.) and Spicy Tuna Roll" },
        { name: "#3 Chirashi", price: 19.95 },
        { name: "#4 Unagidon", price: 22.95 },
        { name: "#5 Salmondon", price: 22.95 }
      ],
    },
    {
      id: "platter",
      name: "Platter",
      items: [
        { name: "GANDA A", price: 39.95, desc: "Sushi (10pcs) and California Roll, Spicy Tuna Roll, and Tempura" },
        { name: "GANDA B", price: 59.95, desc: "Sushi (10pcs), Sashimi (10pcs), and California Roll, Spicy Tuna Roll, and Tempura" },
        { name: "GANDA C", price: 79.95, desc: "Sushi (20pcs), California Roll, Spicy Tuna Roll, Philedelphia Roll, Shrimp Tempura, and Volcano II" },
        { name: "GANDA D", price: 99.95, desc: "Sushi (15pcs), Sashimi (10pcs), California Roll, Spicy Tuna Roll, Philedelphia Roll, Shrimp Tempura, Dragon II, and Volcano II"  },
        { name: "80 pcs. Regular Roll", price: 65.00 },
        { name: "80 pcs. Regular Roll / Special", price: 100.00 },
        { name: "128 pcs. Regular Roll / Special", price: 120.00 },
        { name: "80 pcs. Regular Roll / Special", price: 120.00, desc: "16 pcs Sushi + 64 pcs Mixed" },
        { name: "116 pcs. Regular Roll / Special", price: 150.00, desc: "20 pcs Sushi + 96 pcs Mixed" }
      ],
    },
    {
      id: "bentoboxes",
      name: "Bento Boxes",
      note: "Served with Rice, Salad, Miso Soup, and Edamame, Shumai, California Roll, Mixed Tempura",
      items: [
        { name: "Chicken Teriyaki", price: 23.95 },
        { name: "Shrimp Teriyaki", price: 23.95 },
        { name: "Beef Bulgogi", price: 23.95 },
        { name: "Salmon Teriyaki", price: 23.95 },
        { name: "Pork Katsu", price: 23.95 },
        { name: "Chicken Katsu", price: 23.95 }
      ],
    }
  ],
};

const Menu = () => {
  const [query, setQuery] = useState("");
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    // Initial load from robust storage
    setBookmarks(storage.getBookmarks());

    const updateFromStorage = () => {
      setBookmarks(storage.getBookmarks());
    };

    window.addEventListener('storage_update', updateFromStorage);
    window.addEventListener('storage', updateFromStorage);
    
    return () => {
      window.removeEventListener('storage_update', updateFromStorage);
      window.removeEventListener('storage', updateFromStorage);
    };
  }, []);

  const toggleBookmark = (item, categoryName) => {
    const isBookmarked = bookmarks.some(b => b.name === item.name);
    let updated;
    if (isBookmarked) {
      updated = bookmarks.filter(b => b.name !== item.name);
    } else {
      updated = [...bookmarks, { ...item, category: categoryName }];
    }
    setBookmarks(updated);
    storage.saveBookmarks(updated);
  };

  const filteredMenu = useMemo(() => {
    const q = query.toLowerCase().trim();
    if (!q) return MENU_DATA.categories;
    
    return MENU_DATA.categories.map(cat => ({
      ...cat,
      items: cat.items.filter(it => 
        it.name.toLowerCase().includes(q) || 
        (it.desc && it.desc.toLowerCase().includes(q))
      )
    })).filter(cat => cat.items.length > 0);
  }, [query]);

  const googleMapsUrl = "https://www.google.com/maps/place/Ganda+Sushi/@40.726154,-73.789221,17z/data=!3m1!4b1!4m6!3m5!1s0x89c26100ca7163ad:0x4b7fe7e097bf9f58!8m2!3d40.726154!4d-73.789221!16s%2Fg%2F1thsb8h7?entry=ttu&g_ep=EgoyMDI2MDEwNC4wIKXMDSoKLDEwMDc5MjA3MUgBUAM%3D";

  return (
    <>
      <Helmet>
        <title>Menu - Ganda Sushi | Luxury Korean & Japanese Cuisine</title>
        <meta name="description" content="Explore the exquisite menu at Ganda Sushi. From signature Special Rolls and Spicy Special Rolls to authentic Korean Bento Boxes and fresh Sashimi in Queens, NY." />
        <meta name="keywords" content="Ganda Sushi Menu, Special Rolls, Spicy Tuna, Korean BBQ, Bento Box Queens, Japanese Fusion Menu" />
        <link rel="canonical" href="https://gandasushi.com/menu" />
        <meta property="og:title" content="Menu - Ganda Sushi | Luxury Cuisine" />
        <meta property="og:url" content="https://gandasushi.com/menu" />
      </Helmet>

      <main className="pt-32 pb-24 bg-luxury-cream min-h-screen text-luxury-dark selection:bg-luxury-gold selection:text-white" aria-label="Menu Content">
        <div className="max-w-7xl mx-auto px-6">
          {/* Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="text-center mb-20"
          >
            <div className="flex flex-col items-center gap-6 mb-8">
              <div className="flex items-center justify-center gap-6">
                <div className="w-16 h-16 md:w-20 md:h-20 bg-white rounded-full shadow-lg p-3 flex items-center justify-center border border-luxury-gold/10">
                  <img 
                    src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757795425239-ganda%20sushi%20logo.png" 
                    alt="Ganda Sushi Logo" 
                    className="w-full h-full object-contain"
                  />
                </div>
                <h1 className="text-5xl md:text-8xl font-serif text-luxury-dark tracking-tight">Our Menu</h1>
              </div>
              <span className="text-luxury-gold tracking-[0.5em] uppercase text-[10px] font-black block">Exquisite Asian Fusion</span>
            </div>
            
            <div className="relative max-w-xl mx-auto mt-16">
              <label htmlFor="menu-search" className="sr-only">Search menu items</label>
              <div className="absolute inset-y-0 left-6 flex items-center pointer-events-none">
                <SafeIcon icon={FiSearch} className="text-luxury-gold w-5 h-5" />
              </div>
              <input
                id="menu-search"
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search our culinary craft..."
                className="w-full bg-white border-b border-luxury-gold/30 py-6 pl-14 pr-8 text-luxury-dark focus:outline-none focus:border-luxury-gold transition-all placeholder:text-luxury-dark/30 rounded-none bg-transparent"
              />
            </div>
          </motion.div>

          {/* Two-Column Grid for Categories */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-24 gap-y-24 mt-24">
            {filteredMenu.map((category) => (
              <motion.section 
                key={category.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="space-y-12"
                aria-labelledby={`heading-${category.id}`}
              >
                <div className="border-b border-luxury-gold/10 pb-8">
                  <h2 id={`heading-${category.id}`} className="text-4xl font-serif text-luxury-dark mb-3">{category.name}</h2>
                  {category.note && (
                    <p className="text-luxury-gold text-[10px] tracking-[0.2em] uppercase font-bold italic opacity-80">
                      {category.note}
                    </p>
                  )}
                </div>

                <div className="space-y-10">
                  {category.items.map((item, idx) => {
                    const isBookmarked = bookmarks.some(b => b.name === item.name);
                    return (
                      <div 
                        key={idx} 
                        className="group cursor-default outline-none select-none focus:outline-none relative"
                        style={{ WebkitTapHighlightColor: 'transparent' }}
                        role="article"
                      >
                        <div className="flex justify-between items-baseline mb-3">
                          <div className="flex items-center gap-4">
                            <button 
                              onClick={() => toggleBookmark(item, category.name)}
                              className={`min-w-[44px] min-h-[44px] flex items-center justify-center rounded-full transition-colors duration-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-luxury-gold ${isBookmarked ? 'text-luxury-gold' : 'text-luxury-dark/40 hover:text-luxury-gold'}`}
                              aria-label={isBookmarked ? "Remove from favorites" : "Add to favorites"}
                              aria-pressed={isBookmarked}
                              type="button"
                            >
                              <SafeIcon icon={FiHeart} className={`w-6 h-6 ${isBookmarked ? 'fill-current' : ''}`} />
                            </button>
                            <h3 className="text-xl font-serif text-luxury-dark group-hover:text-luxury-gold transition-colors duration-500">
                              {item.name}
                            </h3>
                          </div>
                          <div className="flex-grow border-b border-luxury-gold/10 mx-6 h-0 opacity-30" />
                          <span className="text-luxury-gold font-serif tabular-nums text-lg" aria-label={`Price: ${item.price.toFixed(2)} dollars`}>
                            ${item.price.toFixed(2)}
                          </span>
                        </div>
                        {item.desc && (
                          <p className="text-luxury-dark/70 text-sm leading-relaxed italic font-light pl-9">
                            {item.desc}
                          </p>
                        )}
                      </div>
                    );
                  })}
                </div>
              </motion.section>
            ))}
          </div>

          {/* Action Section */}
          <section className="mt-40 p-20 bg-white border border-luxury-gold/10 text-center rounded-2xl shadow-2xl relative overflow-hidden" aria-labelledby="cta-heading">
            <div className="absolute top-0 left-0 w-1 h-full bg-luxury-gold" />
            <h2 id="cta-heading" className="text-5xl font-serif text-luxury-dark mb-8">Plan Your Visit</h2>
            <p className="text-luxury-dark/80 mb-12 max-w-xl mx-auto text-lg leading-relaxed font-light">
              Experience the artistry of Ganda Sushi. Order for pickup, get directions to our location, or check our current operating hours.
            </p>
            <div className="flex flex-col md:flex-row justify-center items-center gap-6">
              <Button57 
                href="tel:+17183801818" 
                text="Order Now" 
                altText="Call to Order"
                className="min-w-[200px]"
              />
              <Button57 
                href={googleMapsUrl} 
                text="Directions" 
                altText="Open Maps"
                className="min-w-[200px]"
              />
              <div className="flex items-center gap-3 px-6 py-3 bg-luxury-cream border border-luxury-gold/10 rounded-xl">
                <SafeIcon icon={FiClock} className="text-luxury-gold w-5 h-5" />
                <div className="text-left">
                  <span className="block text-[10px] tracking-widest uppercase font-black text-luxury-dark/40">Hours</span>
                  <span className="text-sm font-medium text-luxury-dark">Tue-Sun 11AM-9PM</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default Menu;